export default __webpack_public_path__ + "static/media/person.6d121fc5.png";